import { gql } from 'react-apollo';

export const deleteDailyScripture = gql`
  mutation deleteDailyScripture($input: DeleteDailyScriptureInput!) {
    deleteDailyScripture(input: $input) {
      scripture {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/mutations/deleteDailyScripture.js